﻿document.addEventListener('DOMContentLoaded', () => {

  // ── 1. QUEEN BEE SHOP TRANSITION ─────────────────────────
  const beeTransition = document.getElementById('beeTransition');
  document.querySelectorAll('a.btn-primary, nav a[href*="/collections"], .mobile-menu a[href*="/collections"]')
    .forEach(link => {
      link.addEventListener('click', e => {
        if (!beeTransition) return;
        if (window.matchMedia('(pointer:coarse)').matches) return;
        if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
        const dest = link.href;
        if (!dest || dest === window.location.href) return;
        e.preventDefault();
        beeTransition.classList.add('active');
        setTimeout(() => { window.location = dest; }, 1700);
      });
    });

  // ── 2. HEADER SCROLL + SHRINK ────────────────────────────
  const header = document.getElementById('mainHeader');
  if (header) {
    let scrollTicking = false;
    window.addEventListener('scroll', () => {
      if (!scrollTicking) {
        requestAnimationFrame(() => {
          const y = window.scrollY;
          header.classList.toggle('scrolled', y > 20);
          header.classList.toggle('shrunk', y > 90);
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }, { passive: true });
  }

  // ── 3. MOBILE MENU ───────────────────────────────────────
  const mobileToggle = document.getElementById('mobileToggle');
  const mobileClose  = document.getElementById('mobileClose');
  const mobileMenu   = document.getElementById('mobileMenu');
  const closeMobileMenu = () => { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; };
  if (mobileToggle) mobileToggle.addEventListener('click', () => { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; });
  if (mobileClose)  mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileMenu)   mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMobileMenu));

  // ── 4. CURSOR AMBIENT GLOW ───────────────────────────────
  const cursorGlow = document.getElementById('cursorGlow');
  if (cursorGlow && window.matchMedia('(pointer:fine)').matches) {
    let gx = 0, gy = 0, tx = 0, ty = 0;
    document.addEventListener('mousemove', e => { tx = e.clientX; ty = e.clientY; }, { passive: true });
    (function driftGlow() {
      gx += (tx - gx) * 0.07;
      gy += (ty - gy) * 0.07;
      cursorGlow.style.transform = `translate(${gx}px,${gy}px)`;
      requestAnimationFrame(driftGlow);
    })();
    document.addEventListener('mouseleave', () => cursorGlow.style.opacity = '0');
    document.addEventListener('mouseenter', () => cursorGlow.style.opacity = '');
  }

  // ── 5. SCROLL REVEAL ─────────────────────────────────────
  const revealSelectors = [
    '.iwt','.section-header','.product-card','.article-card',
    '.trust-item','.counter-item','.ingredient-card',
    '.testimonial-item',
    '.cart-item','.not-found','footer .footer-grid'
  ];
  revealSelectors.forEach(sel =>
    document.querySelectorAll(sel).forEach(el => el.classList.add('reveal'))
  );
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('revealed'); revealObs.unobserve(e.target); }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  // ── 6. MOUSE PARALLAX ON HERO ────────────────────────────
  const heroEl = document.querySelector('.hero');
  if (heroEl) {
    let ticking = false;
    heroEl.addEventListener('mousemove', e => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const r = heroEl.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width  - 0.5;
        const y = (e.clientY - r.top)  / r.height - 0.5;
        const cvs = document.getElementById('heroCanvas');
        if (cvs) cvs.style.transform = `translate(${x*-7}px,${y*-4}px)`;
        ticking = false;
      });
    });
    heroEl.addEventListener('mouseleave', () => {
      const cvs = document.getElementById('heroCanvas');
      if (cvs) cvs.style.transform = '';
    });
  }

  // ── 8. COUNTER ANIMATION ─────────────────────────────────
  const easeOut = t => t * (2 - t);
  function runCounter(el) {
    const target = parseFloat(el.dataset.target);
    const suffix = el.dataset.suffix || '';
    const start  = performance.now();
    const dur    = 1900;
    (function tick(now) {
      const t = Math.min((now - start) / dur, 1);
      const v = target * easeOut(t);
      el.textContent = (Number.isInteger(target) ? Math.floor(v) : v.toFixed(1)) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    })(start);
  }
  const cntObs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { runCounter(e.target); cntObs.unobserve(e.target); } });
  }, { threshold: 0.5 });
  document.querySelectorAll('.counter-number[data-target]').forEach(el => cntObs.observe(el));

  // ── 9. BFCACHE: clear bee if user navigates back ─────────────
  window.addEventListener('pageshow', e => {
    if (e.persisted && beeTransition) beeTransition.classList.remove('active');
  });

  // ── BUNDLE PICKER ────────────────────────────────────────
  const bundlePicker = document.getElementById('bundlePicker');
  if (bundlePicker) {
    let activeBundleIdx = 0;

    const allVariants = (() => {
      try { return JSON.parse(document.getElementById('productVariantsData').textContent); }
      catch(e) { return []; }
    })();
    function variantIdByPrice(p) {
      const v = allVariants.find(v => parseInt(v.price, 10) === p);
      return v ? String(v.id) : null;
    }

    function fmtNOK(cents) {
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'NOK';
      const loc = document.documentElement.lang || 'nb';
      return new Intl.NumberFormat(loc, {style:'currency',currency:cur,minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
    }

    const bpOptions  = bundlePicker.querySelectorAll('.bundle-picker__option');
    const bpPriceEls = bundlePicker.querySelectorAll('.bundle-picker__price-display');

    // Prices and variant IDs come directly from Liquid data attributes — no calculation
    bpPriceEls.forEach((el, i) => {
      const price = parseInt(bpOptions[i].dataset.price, 10);
      if (price) el.textContent = fmtNOK(price);
    });

    const initVid = (bpOptions[0] && bpOptions[0].dataset.variantId) || variantIdByPrice(49900);
    if (initVid) { const el = document.getElementById('variantId'); if (el) el.value = initVid; }

    bpOptions.forEach((opt, i) => {
      opt.addEventListener('click', () => {
        bpOptions.forEach(o => o.classList.remove('active'));
        opt.classList.add('active');
        activeBundleIdx = i;
        document.querySelectorAll('.sub-picker__row').forEach(r => r.classList.remove('is-selected'));
        const price = parseInt(opt.dataset.price, 10);
        const vid = opt.dataset.variantId || variantIdByPrice(price);
        if (vid) { const el = document.getElementById('variantId'); if (el) el.value = vid; }
        const priceEl = document.getElementById('productPrice');
        if (priceEl && price) priceEl.textContent = fmtNOK(price);
      });
    });

    // AJAX add to cart — stay on page, update header badge
    const productForm = document.getElementById('productForm');
    if (productForm) {
      productForm.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = productForm.querySelector('.btn-add-to-cart');
        const orig = btn.textContent;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        try {
          const variantId = document.getElementById('variantId').value;
          const qty = 1;
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
          });
          if (!r.ok) throw new Error();
          // Update header cart count
          const cart = await fetch('/cart.js').then(res => res.json());
          const cartLink = document.querySelector('a[href="/cart"]');
          if (cartLink) {
            let badge = cartLink.querySelector('.cart-count');
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'cart-count';
              cartLink.appendChild(badge);
            }
            badge.textContent = cart.item_count;
            badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
          const floatingCount = document.getElementById('floatingCartCount');
          if (floatingCount) {
            floatingCount.textContent = cart.item_count;
            floatingCount.classList.toggle('floating-cart__count--hidden', cart.item_count === 0);
          }
          btn.textContent = 'Added to Cart';
          setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
        } catch {
          btn.textContent = orig;
          btn.disabled = false;
        }
      });
    }
  }

  // ── SUBSCRIPTION PICKER ──────────────────────────────────
  const subPicker = document.getElementById('subPicker');
  if (subPicker) {
    const subVariants = (() => {
      try { return JSON.parse(document.getElementById('productVariantsData').textContent); }
      catch(e) { return []; }
    })();
    const subPriceMap = { monthly: 44910, '2months': 47405, '3months': 47405 };
    const subRows = subPicker.querySelectorAll('.sub-picker__row');

    function fmtSub(cents) {
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'NOK';
      const loc = document.documentElement.lang || 'nb';
      return new Intl.NumberFormat(loc, {style:'currency',currency:cur,minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
    }

    let savedBundleOption = null;

    subRows.forEach(row => {
      row.addEventListener('click', e => {
        if (e.target.type === 'radio') return;
        const radio = row.querySelector('input[type="radio"]');
        if (!radio) return;
        const wasSelected = row.classList.contains('is-selected');
        subRows.forEach(r => r.classList.remove('is-selected'));
        if (!wasSelected) {
          row.classList.add('is-selected');
          radio.checked = true;
          savedBundleOption = document.querySelector('.bundle-picker__option.active');
          document.querySelectorAll('.bundle-picker__option').forEach(o => o.classList.remove('active'));
          const vid = row.dataset.variantId;
          if (vid) { const el = document.getElementById('variantId'); if (el) el.value = vid; }
          const priceEl = document.getElementById('productPrice');
          if (priceEl && row.dataset.money) priceEl.textContent = row.dataset.money;
        } else {
          radio.checked = false;
          const restore = savedBundleOption || document.querySelector('.bundle-picker__option');
          if (restore) {
            restore.classList.add('active');
            const vid = restore.dataset.variantId;
            if (vid) { const el = document.getElementById('variantId'); if (el) el.value = vid; }
            const priceEl = document.getElementById('productPrice');
            if (priceEl && restore.dataset.price) priceEl.textContent = fmtNOK(parseInt(restore.dataset.price, 10));
          }
        }
      });
    });
  }

  // ── PRODUCT GALLERY ──────────────────────────────────────
  const galleryImagesEl = document.getElementById('galleryImages');
  if (galleryImagesEl) {
    const images  = JSON.parse(galleryImagesEl.textContent);
    const mainImg = document.getElementById('mainImg');
    const thumbs  = document.querySelectorAll('.product-gallery__thumb');
    const dots    = document.querySelectorAll('.gallery-dot');
    let current   = 0;

    // Preload all gallery images so switches are instant
    images.forEach(src => { const pre = new Image(); pre.src = src; });

    function goTo(index) {
      current = (index + images.length) % images.length;
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.onload = () => { mainImg.style.opacity = '1'; mainImg.onload = null; };
          mainImg.src = images[current];
          if (mainImg.complete) { mainImg.onload = null; mainImg.style.opacity = '1'; }
        }, 180);
      }
      thumbs.forEach((t, i) => t.classList.toggle('active', i === current));
      dots.forEach((d, i)   => d.classList.toggle('active', i === current));
    }

    // Thumbnails
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));

    // Dot indicators
    dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));

    // Touch swipe
    const mainImageEl = document.getElementById('mainImage');
    if (mainImageEl) {
      let touchStartX = 0;
      let touchStartY = 0;

      mainImageEl.addEventListener('touchstart', e => {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });
      mainImageEl.addEventListener('touchend', e => {
        const deltaX = e.changedTouches[0].clientX - touchStartX;
        const deltaY = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) > 60 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) {
          goTo(deltaX < 0 ? current + 1 : current - 1);
        }
      });
    }

    // One-time swipe hint — nudges the image on first visit so shoppers notice it's a carousel
    if (images.length > 1 && mainImageEl) {
      let hintSeen = false;
      try { hintSeen = localStorage.getItem('ar_gallery_hint_seen_v2') === '1'; } catch (e) {}
      if (!hintSeen) {
        setTimeout(() => {
          mainImageEl.classList.add('gallery-hint');
          setTimeout(() => mainImageEl.classList.remove('gallery-hint'), 2700);
        }, 1000);
        try { localStorage.setItem('ar_gallery_hint_seen_v2', '1'); } catch (e) {}
      }
    }

    // Keyboard arrows when gallery is focused
    document.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Auto-advance — desktop only, always exactly 3.5s from the last change, pauses on hover
    if (images.length > 1 && !window.matchMedia('(max-width:768px)').matches) {
      let autoTimer;
      const startTimer = () => {
        clearInterval(autoTimer);
        autoTimer = setInterval(() => goTo(current + 1), 3500);
      };
      startTimer();

      if (mainImageEl) {
        mainImageEl.addEventListener('mouseenter', () => clearInterval(autoTimer));
        mainImageEl.addEventListener('mouseleave', startTimer);
        mainImageEl.addEventListener('touchstart', () => clearInterval(autoTimer), { passive: true });
        mainImageEl.addEventListener('touchend',   startTimer, { passive: true });
      }

      // Pause when hovering the thumbnails
      const thumbsWrap = document.querySelector('.product-gallery__thumbs');
      if (thumbsWrap) {
        thumbsWrap.addEventListener('mouseenter', () => clearInterval(autoTimer));
        thumbsWrap.addEventListener('mouseleave', startTimer);
      }

      // Reset the countdown on any manual navigation
      thumbs.forEach(t => t.addEventListener('click', startTimer));
      dots.forEach(d => d.addEventListener('click', startTimer));
    }
  }

  // ── PRODUCT VARIANTS ─────────────────────────────────────
  const variantsEl = document.getElementById('productVariantsData');
  if (variantsEl) {
    const variants = JSON.parse(variantsEl.textContent);
    const optionGroups = document.querySelectorAll('[data-option-index]');
    function updateVariant() {
      const selected = Array.from(optionGroups).map(g => g.querySelector('.active')?.dataset.value);
      const match = variants.find(v => v.options.every((o, i) => o === selected[i]));
      if (match) {
        document.getElementById('variantId').value = match.id;
        const price = new Intl.NumberFormat(document.documentElement.lang,
          { style: 'currency', currency: window.Shopify?.currency?.active || 'NOK' }
        ).format(match.price / 100);
        const priceEl = document.getElementById('productPrice');
        if (priceEl) priceEl.textContent = price;
      }
    }
    optionGroups.forEach(g => {
      g.querySelectorAll('.product-form__option').forEach(btn => {
        btn.addEventListener('click', () => {
          g.querySelectorAll('.product-form__option').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          updateVariant();
        });
      });
    });
  }

  // ── CART QTY BUTTONS ────────────────────────────────────
  window.changeQty = (btn, delta) => {
    const input = btn.parentElement.querySelector('input');
    input.value = Math.max(0, parseInt(input.value) + delta);
  };

});

// ── PDP TABS (Reviews / FAQ) ─────────────────────────────────
(function() {
  const tabBtns   = document.querySelectorAll('.pdp-tabs__btn');
  const tabPanels = document.querySelectorAll('.pdp-tabs__panel');
  if (!tabBtns.length) return;
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('is-active'));
      tabPanels.forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      const panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('is-active');
    });
  });
})();

// ── FAQ ACCORDION ────────────────────────────────────────────
document.querySelectorAll('.faq-item__q').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('is-open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('is-open'));
    document.querySelectorAll('.faq-item__q').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (!isOpen) {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

// ── EMAIL POPUP ───────────────────────────────────────────────
(function() {
  if (localStorage.getItem('ar-popup-seen')) return;
  const overlay = document.getElementById('emailPopup');
  if (!overlay) return;

  function dismiss() {
    overlay.classList.remove('is-visible');
    overlay.setAttribute('aria-hidden', 'true');
    localStorage.setItem('ar-popup-seen', '1');
  }

  function show() {
    if (overlay.classList.contains('is-visible')) return;
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
  }

  setTimeout(show, 4000);

  document.addEventListener('mouseleave', function(e) {
    if (e.clientY <= 0) show();
  });

  document.getElementById('popupClose').addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) dismiss(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') dismiss(); });

  document.getElementById('popupSubmit').addEventListener('click', function() {
    const emailEl = document.getElementById('popupEmail');
    const email = emailEl.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      emailEl.focus();
      return;
    }
    const fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter');
    fetch('/contact', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    document.getElementById('popupForm').style.display = 'none';
    document.getElementById('popupSuccess').style.display = 'block';
    localStorage.setItem('ar-popup-seen', '1');
  });

  document.getElementById('popupEmail').addEventListener('keydown', function(e) {
    if (e.key === 'Enter') document.getElementById('popupSubmit').click();
  });
})();

// ── COOKIE CONSENT ───────────────────────────────────────────
(function() {
  const banner = document.getElementById('cookieBanner');
  if (!banner) return;
  if (localStorage.getItem('ar-cookie-consent')) return;
  requestAnimationFrame(() => banner.classList.add('is-visible'));
  document.getElementById('cookieAccept').addEventListener('click', function() {
    localStorage.setItem('ar-cookie-consent', 'accepted');
    banner.classList.remove('is-visible');
  });
  document.getElementById('cookieDecline').addEventListener('click', function() {
    localStorage.setItem('ar-cookie-consent', 'declined');
    banner.classList.remove('is-visible');
  });
})();

// ── AUTO LANGUAGE DETECTION ──────────────────────────────────
(function() {
  if (sessionStorage.getItem('ar-locale-set')) return;
  sessionStorage.setItem('ar-locale-set', '1');
  const lang = (navigator.language || navigator.userLanguage || '').toLowerCase().split('-')[0];
  const map = { sv:'sv', nb:'nb', nn:'nb', da:'da', fi:'fi', de:'de', fr:'fr', nl:'nl', es:'es', it:'it', pl:'pl', pt:'pt', cs:'cs', hu:'hu', ro:'ro', sk:'sk', hr:'hr', bg:'bg', el:'el' };
  const target = map[lang];
  if (!target) return;
  const currentLang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
  if (currentLang === target) return;
  const form = document.querySelector('.localization-form');
  const select = form && form.querySelector('select[name="locale_code"]');
  if (!select) return;
  const opt = Array.from(select.options).find(o => o.value.toLowerCase().startsWith(target));
  if (opt) { select.value = opt.value; form.submit(); }
})();

// ── PDP INLINE EMAIL SIGNUP ──────────────────────────────────
(function() {
  var btn = document.getElementById('pdpSubmit');
  if (!btn) return;
  btn.addEventListener('click', function() {
    var emailEl = document.getElementById('pdpEmail');
    var email = emailEl.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { emailEl.focus(); return; }
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter,pdp-signup');
    fetch('/contact', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    document.getElementById('pdpSignupForm').style.display = 'none';
    document.getElementById('pdpSuccess').style.display = 'block';
    localStorage.setItem('ar-popup-seen', '1');
  });
  document.getElementById('pdpEmail').addEventListener('keydown', function(e) {
    if (e.key === 'Enter') btn.click();
  });
})();

// ── STICKY ATC ───────────────────────────────────────────────
(function() {
  const mainBtn = document.querySelector('.btn-add-to-cart');
  const bar     = document.getElementById('stickyAtc');
  const stickyBtn  = document.getElementById('stickyAtcBtn');
  const stickyPrice = document.getElementById('stickyPrice');
  if (!mainBtn || !bar) return;

  const obs = new IntersectionObserver(([e]) => {
    bar.classList.toggle('is-visible', !e.isIntersecting);
    bar.setAttribute('aria-hidden', String(e.isIntersecting));
  }, { threshold: 0 });
  obs.observe(mainBtn);

  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const form = document.getElementById('productForm');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  // Keep sticky price in sync with bundle/sub picker changes
  const priceEl = document.getElementById('productPrice');
  if (priceEl && stickyPrice) {
    new MutationObserver(() => { stickyPrice.textContent = priceEl.textContent; })
      .observe(priceEl, { childList: true, characterData: true, subtree: true });
  }
})();

// ── PHILOSOPHY PAGE CANVAS — slow floating particles ────────
const philCanvas = document.getElementById('philCanvas');
if (philCanvas && !window.matchMedia('(pointer:coarse)').matches) {
  const pc = philCanvas.getContext('2d');
  function philResize() {
    philCanvas.width  = window.innerWidth;
    philCanvas.height = window.innerHeight;
  }
  window.addEventListener('resize', philResize, { passive: true });
  philResize();

  const philParticles = Array.from({ length: 55 }, () => ({
    x: Math.random() * window.innerWidth,
    y: Math.random() * window.innerHeight,
    r: Math.random() * 1.3 + 0.2,
    vy: Math.random() * 0.22 + 0.06,
    vx: (Math.random() - 0.5) * 0.12,
    o: Math.random() * 0.18 + 0.04
  }));

  (function philFrame() {
    pc.clearRect(0, 0, philCanvas.width, philCanvas.height);
    philParticles.forEach(p => {
      p.y -= p.vy;
      p.x += p.vx;
      if (p.y < -8) { p.y = philCanvas.height + 8; p.x = Math.random() * philCanvas.width; }
      pc.globalAlpha = p.o;
      pc.fillStyle = '#C9A84C';
      pc.beginPath();
      pc.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      pc.fill();
    });
    pc.globalAlpha = 1;
    requestAnimationFrame(philFrame);
  })();
}

// ── HERO CANVAS HONEYCOMB (runs immediately) ──────────────
const canvas = document.getElementById('heroCanvas');
if (canvas) {
  const ctx = canvas.getContext('2d');
  let time = 0;
  function resize() { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; }
  window.addEventListener('resize', resize);
  resize();
  const R = 38, gap = 3;
  const W = Math.sqrt(3) * R + gap;
  const H = R * 1.5 + gap * 0.87;
  function drawHex(x, y, r, alpha) {
    ctx.beginPath();
    for (let i = 0; i < 6; i++) {
      const a = (Math.PI / 3) * i - Math.PI / 6;
      i === 0 ? ctx.moveTo(x + r*Math.cos(a), y + r*Math.sin(a))
              : ctx.lineTo(x + r*Math.cos(a), y + r*Math.sin(a));
    }
    ctx.closePath();
    ctx.strokeStyle = `rgba(201,168,76,${alpha.toFixed(3)})`;
    ctx.lineWidth = 0.6;
    ctx.stroke();
  }
  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    const cols = Math.ceil(canvas.width / W) + 3;
    const rows = Math.ceil(canvas.height / H) + 3;
    const cx = canvas.width * 0.5, cy = canvas.height * 0.5;
    for (let row = -1; row < rows; row++) {
      for (let col = -1; col < cols; col++) {
        const x = col * W + (row % 2 !== 0 ? W / 2 : 0);
        const y = row * H;
        const dist = Math.sqrt((x-cx)**2 + (y-cy)**2);
        const wave = Math.sin(dist / 90 - time * 0.6) * 0.5 + 0.5;
        const falloff = Math.max(0, 1 - dist / (canvas.width * 0.72));
        const alpha = wave * falloff * 0.11 + falloff * 0.03;
        if (alpha > 0.005) drawHex(x, y, R - gap * 0.5, alpha);
      }
    }
  }
  draw();
  window.addEventListener('resize', draw);
}
